import React from 'react';
import "../assets/scss/components/progressbar.scss"

const ProgressBar = (props) => {
    return (
        <div className={`progress-bar ${(props.class) ? props.class : ''}`}>
            <h2 className="progress-bar__title">{props.title}</h2>
            <div className="progress-bar-graphic">
                <div className="progress-bar-graphic--progress" style={{width: props.progress + '%'}}></div>
            </div>
            {props.steps &&
            <div className="progress-bar-steps">
                {props.steps.map((step, index)=> (
                    <div key={index} className={`progress-bar-step ${step.active ? 'active' : ''}`}>
                        {step.active}
                        <span className="progress-bar-step__num">{index + 1}</span>{step.name}
                    </div>
                ))}
            </div>}

        </div>
    );
};

export default ProgressBar;
